import React from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import WidgetTemplate from './Template'

const BodyControl = (props) => {
  return <WidgetTemplate props={props} layout="body" />
}

export const bodyControlTester = rankWith(3, scopeEndsWith('body'))

export default withJsonFormsControlProps(BodyControl)
